<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

const emit = defineEmits<{
  (e: 'close'): void;
}>();

type ConfirmationDialogProps = {
  menuX?: number;
  menuY?: number;
  link?: string;
};
const props = withDefaults(defineProps<ConfirmationDialogProps>(), {
  menuX: 0,
  menuY: 0,
  link: '',
});

const onOpenInNewTab = () => {
  window.open(props.link, '_blank');
  emit('close');
};

const clickOutsiteHandler = (e: Event) => {
  const inside = (e.target as HTMLElement).closest('#liv-contenxt-menu');
  if (!inside) {
    emit('close');
  }
};

onMounted(async () => {
  // Note : Added this as v-click-outside not working
  document.addEventListener('click', clickOutsiteHandler);
});

onUnmounted(() => {
  document.removeEventListener('click', clickOutsiteHandler);
});
</script>
<template>
  <div
    id="liv-contenxt-menu"
    class="contenxt-menu-wrapper"
    :style="{ top: menuY + 'px', left: menuX + 'px' }"
  >
    <div
      class="context-menu-option"
      @click="onOpenInNewTab()"
    >
      Open in new tab
    </div>
  </div>
</template>

<style>
.contenxt-menu-wrapper {
  position: fixed;
  /* Updated ZIndex to resolve overlap issue when opened inside v-dialog component */
  z-index: 9999;
  top: 0;
  left: 0;
  background: #fff;
  height: auto;
  width: auto;
  min-width: 150px;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 20px 0 rgba(0, 0, 0, 0.19);
  font-size: 16px;
  font-weight: 500;
}
.context-menu-option {
  padding: 5px;
}
.context-menu-option:hover {
  cursor: pointer;
  color: var(--livi-primary);
  font-weight: 700;
}
</style>
